import { t } from "@/i18n-js/instance";

import { VisibilityField } from "../fields/VisibilityField";
import { SectionShell } from "../SectionShell";

export const AccessSection = () => (
  <SectionShell title={t("spaces.form.create.sections.access")}>
    <VisibilityField />
  </SectionShell>
);
